var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeData["start-placeholder"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "开始占位" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入占位提示" },
                model: {
                  value: _vm.activeData["start-placeholder"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "start-placeholder", $$v)
                  },
                  expression: "activeData['start-placeholder']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData["end-placeholder"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "结束占位" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入占位提示" },
                model: {
                  value: _vm.activeData["end-placeholder"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData, "end-placeholder", $$v)
                  },
                  expression: "activeData['end-placeholder']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-tooltip",
        {
          attrs: {
            effect: "dark",
            content: "默认时间为当时填写的时间",
            placement: "top",
          },
        },
        [
          _c(
            "el-form-item",
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(" 默认当时 "),
                _c("i", { staticClass: "el-icon-question" }),
              ]),
              _c("el-switch", {
                model: {
                  value: _vm.activeData.config["defaultNowTime"],
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.config, "defaultNowTime", $$v)
                  },
                  expression: "activeData.config['defaultNowTime']",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.activeData.type !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "时间类型" } },
            [
              _c(
                "el-select",
                {
                  style: { width: "100%" },
                  attrs: { placeholder: "请选择时间类型" },
                  on: { change: _vm.dateTypeChange },
                  model: {
                    value: _vm.activeData.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "type", $$v)
                    },
                    expression: "activeData.type",
                  },
                },
                _vm._l(_vm.dateTypeOptions, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.format !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "时间格式" } },
            [
              _c("el-input", {
                attrs: {
                  value: _vm.activeData.format,
                  placeholder: "请输入时间格式",
                },
                on: {
                  input: function ($event) {
                    return _vm.setTimeValue($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }